import axios from 'axios'

let baseURL = ''
const loc = window.location.host
if (loc.includes('localhost')) {
    baseURL = `http://localhost:8181`
}
// baseURL = `https://dms.happymint.dev`
export default class FileUtil {
    getFileUrl (fileId) {
        if (fileId === null || fileId === '' || fileId <= 0 || fileId === undefined) return null
        let DOWNLOAD_URL = baseURL + '/user/apis/v1/file/download?fileId=' + fileId
        return DOWNLOAD_URL
    }
    getDownUrl (fileName) {
        if (fileName === null || fileName === '' || fileName === undefined) return null
        let DOWNLOAD_URL = baseURL + '/user/apis/v1/file/' + fileName + '/download'
        // console.log('DOWNLOAD_URL:', DOWNLOAD_URL)
        return DOWNLOAD_URL
    }
    async fileUpload(formData) {

        let responseData
        await axios.post(baseURL + '/user/apis/v1/file/upload',
            formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then( response => {
            responseData = response.data;
        })
            .catch(async error => {
                console.log(error)
            })

        return responseData
    }
    async fileEnable(fileIdList) {

        if (fileIdList === null || fileIdList.size < 1 || fileIdList === undefined) return null

        var formData = new FormData();

        fileIdList.forEach((fileId) => {
            formData.append('enableFileIds', fileId)
        })

        let responseData

        // 임시 post
        await axios.post(baseURL + '/user/apis/v1/file/enable',
                formData, {
                    headers: {
                        "Access-Control-Allow-Origin": "*"
                    }
                },
            ).then( response => {
                responseData = response.data;
            })
            .catch(async error => {
                console.log(error)
            })

        return responseData
    }
    async fileDelete(fileIdList) {

        // if (fileIdList === null || fileIdList === '' || fileIdList === 0 || fileIdList === undefined) return null

        var formData = new FormData();
        formData.append('beforeFileId', fileIdList);
        let responseData

        await axios.post(baseURL + '/user/apis/v1/file/delete',
                formData, {
                    headers: {
                        "Access-Control-Allow-Origin": "*"
                    }
                },
            ).then( response => {
                responseData = response.data;
            })
            .catch(async error => {
                console.log(error)
            })

        return responseData
    }

}